
import { TranslationsByLanguage } from './types';

export type CreatorTranslationKey =
  | 'creator.dashboard'
  | 'creator.profile'
  | 'creator.derivatives'
  | 'creator.downloads'
  | 'creator.settings'
  | 'creator.welcome'
  | 'creator.pleaseLogin'
  | 'creator.loading'
  | 'creator.myDerivatives'
  | 'creator.newDerivative'
  | 'creator.createDerivative'
  | 'creator.yourCreations'
  | 'creator.manageCreations'
  | 'creator.refresh'
  | 'creator.createNew'
  | 'creator.noDerivatives'
  | 'creator.createNewDerivativeSuggestion'
  | 'creator.manageContent'
  | 'creator.myChannels'
  | 'creator.myClips'
  | 'creator.myPlaylists'
  | 'creator.analytics'
  | 'creator.newChannel'
  | 'creator.newPlaylist'
  | 'creator.manageChannel'
  | 'creator.noChannels'
  | 'creator.createFirstChannel'
  | 'creator.noClips'
  | 'creator.createFirstDerivative'
  | 'creator.noPlaylists'
  | 'creator.createFirstPlaylist'
  | 'creator.analyticsDesc'
  | 'creator.analyticsSoon'
  | 'creator.channelFeatureComing'
  | 'creator.playlistFeatureComing'
  | 'creator.needCreatorAccount'
  | 'creator.loginRequired'
  | 'creator.deleteSuccess';

export const creatorTranslations: TranslationsByLanguage = {
  en: {
    'creator.dashboard': 'Creator Dashboard',
    'creator.profile': 'Profile',
    'creator.derivatives': 'Derivatives',
    'creator.downloads': 'Downloads',
    'creator.settings': 'Settings',
    'creator.welcome': 'Welcome to the Creator Dashboard',
    'creator.pleaseLogin': 'Please log in to access your creator dashboard',
    'creator.loading': 'Loading your creator profile...',
    'creator.myDerivatives': 'My Derivatives',
    'creator.newDerivative': '+ New Derivative',
    'creator.createDerivative': 'Create Derivative',
    'creator.yourCreations': 'Your Creations',
    'creator.manageCreations': 'Manage your derivative works',
    'creator.refresh': 'Refresh',
    'creator.createNew': 'Create',
    'creator.noDerivatives': 'You have no derivatives in this category',
    'creator.createNewDerivativeSuggestion': 'Why not create a new derivative?',
    'creator.manageContent': 'Manage your content and channels',
    'creator.myChannels': 'My Channels',
    'creator.myClips': 'My Clips',
    'creator.myPlaylists': 'My Playlists',
    'creator.analytics': 'Analytics',
    'creator.newChannel': 'New Channel',
    'creator.newPlaylist': 'New Playlist',
    'creator.manageChannel': 'Manage Channel',
    'creator.noChannels': 'You have not created any channels yet',
    'creator.createFirstChannel': 'Create Your First Channel',
    'creator.noClips': 'You have not uploaded any clips yet',
    'creator.createFirstDerivative': 'Create Your First Derivative',
    'creator.noPlaylists': 'You have not created any playlists yet',
    'creator.createFirstPlaylist': 'Create Your First Playlist',
    'creator.analyticsDesc': 'Track performance of your content',
    'creator.analyticsSoon': 'Analytics will be available soon',
    'creator.channelFeatureComing': 'Channel creation feature will be available soon',
    'creator.playlistFeatureComing': 'Playlist creation feature will be available soon',
    'creator.needCreatorAccount': 'You need a creator account to access this page',
    'creator.loginRequired': 'You need to be logged in to access the creator dashboard',
    'creator.deleteSuccess': 'The item has been successfully deleted'
  },
  fr: {
    'creator.dashboard': 'Dashboard Créateur',
    'creator.profile': 'Profil',
    'creator.derivatives': 'Dérivés',
    'creator.downloads': 'Téléchargements',
    'creator.settings': 'Paramètres',
    'creator.welcome': 'Bienvenue sur le Dashboard Créateur',
    'creator.pleaseLogin': 'Veuillez vous connecter pour accéder à votre dashboard',
    'creator.loading': 'Chargement de votre profil créateur...',
    'creator.myDerivatives': 'Mes Dérivés',
    'creator.newDerivative': '+ Nouveau Dérivé',
    'creator.createDerivative': 'Créer un Dérivé',
    'creator.yourCreations': 'Vos Créations',
    'creator.manageCreations': 'Gérez vos œuvres dérivées',
    'creator.refresh': 'Actualiser',
    'creator.createNew': 'Créer',
    'creator.noDerivatives': 'Vous n\'avez pas de dérivés dans cette catégorie',
    'creator.createNewDerivativeSuggestion': 'Pourquoi ne pas créer un nouveau dérivé ?',
    'creator.manageContent': 'Gérez votre contenu et vos chaînes',
    'creator.myChannels': 'Mes Chaînes',
    'creator.myClips': 'Mes Clips',
    'creator.myPlaylists': 'Mes Listes de lecture',
    'creator.analytics': 'Analytiques',
    'creator.newChannel': 'Nouvelle Chaîne',
    'creator.newPlaylist': 'Nouvelle Liste',
    'creator.manageChannel': 'Gérer la Chaîne',
    'creator.noChannels': 'Vous n\'avez pas encore créé de chaînes',
    'creator.createFirstChannel': 'Créer Votre Première Chaîne',
    'creator.noClips': 'Vous n\'avez pas encore téléchargé de clips',
    'creator.createFirstDerivative': 'Créer Votre Premier Dérivé',
    'creator.noPlaylists': 'Vous n\'avez pas encore créé de listes de lecture',
    'creator.createFirstPlaylist': 'Créer Votre Première Liste',
    'creator.analyticsDesc': 'Suivez les performances de votre contenu',
    'creator.analyticsSoon': 'Les analytiques seront disponibles prochainement',
    'creator.channelFeatureComing': 'La fonctionnalité de création de chaîne sera disponible prochainement',
    'creator.playlistFeatureComing': 'La fonctionnalité de création de liste sera disponible prochainement',
    'creator.needCreatorAccount': 'Vous avez besoin d\'un compte créateur pour accéder à cette page',
    'creator.loginRequired': 'Vous devez être connecté pour accéder au dashboard créateur',
    'creator.deleteSuccess': 'L\'élément a été supprimé avec succès'
  }
};
